import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Save, RefreshCw } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminSettings = () => {
  const [stats, setStats] = useState({ students: 0, courses: 0, years: 0, pillars: 0 });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/stats`);
        setStats(res.data);
      } catch (e) { console.error(e); }
    };
    fetch();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/stats`, stats, { withCredentials: true });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (e) { alert('Error saving stats'); }
    setSaving(false);
  };

  const handleSeed = async () => {
    if (!window.confirm('This will reset ALL content data (courses, books, guides, apps, websites). Proceed?')) return;
    try {
      await axios.post(`${API}/seed`);
      alert('Data re-seeded successfully!');
    } catch (e) { alert('Error seeding data'); }
  };

  return (
    <div>
      {/* Site Statistics */}
      <div style={{ background: 'rgba(88,28,135,0.12)', border: '1px solid rgba(139,92,246,0.2)', borderRadius: 14, padding: 28, marginBottom: 28 }}>
        <h3 style={{ fontSize: 18, fontWeight: 700, color: '#e0dff0', marginBottom: 20 }}>Site Statistics</h3>
        <p style={{ fontSize: 13, color: '#8885a0', marginBottom: 20 }}>These numbers are displayed on the homepage stats section.</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
          {[
            { key: 'students', label: 'Students Worldwide' },
            { key: 'courses', label: 'Premium Courses' },
            { key: 'years', label: 'Years Experience' },
            { key: 'pillars', label: 'Spiritual Pillars' },
          ].map(field => (
            <div key={field.key}>
              <label style={{ fontSize: 13, color: '#b0adc0', marginBottom: 6, display: 'block' }}>{field.label}</label>
              <input
                type="number"
                value={stats[field.key] || 0}
                onChange={e => setStats(p => ({ ...p, [field.key]: parseInt(e.target.value) || 0 }))}
                style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid rgba(139,92,246,0.3)', background: 'rgba(88,28,135,0.12)', color: '#fff', fontSize: 16, fontWeight: 700, outline: 'none', fontFamily: 'Inter, sans-serif' }}
              />
            </div>
          ))}
        </div>
        <button onClick={handleSave} disabled={saving} style={{ marginTop: 20, padding: '12px 28px', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#7c3aed,#a855f7)', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, fontWeight: 600, opacity: saving ? 0.6 : 1 }}>
          <Save size={16} /> {saving ? 'Saving...' : saved ? 'Saved!' : 'Save Statistics'}
        </button>
      </div>

      {/* Danger Zone */}
      <div style={{ background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 14, padding: 28 }}>
        <h3 style={{ fontSize: 18, fontWeight: 700, color: '#ef4444', marginBottom: 8 }}>Danger Zone</h3>
        <p style={{ fontSize: 13, color: '#8885a0', marginBottom: 20 }}>These actions cannot be undone. Proceed with caution.</p>
        <button onClick={handleSeed} style={{ padding: '12px 24px', borderRadius: 10, border: '1px solid rgba(239,68,68,0.4)', background: 'transparent', color: '#ef4444', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, fontWeight: 600 }}>
          <RefreshCw size={16} /> Re-seed All Content Data
        </button>
      </div>
    </div>
  );
};

export default AdminSettings;
